/* eslint-disable no-param-reassign */
import Vue from 'vue';
import EmailValidator from 'email-validator'

const ValidationPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $rules() {
          return {
            required: value => !!value || this.$t('validation.field_is_required'),
            email: value => EmailValidator.validate(value) || this.$t('validation.field_type_email'),
          };
        },
      },
    });
  },
};

export default ValidationPlugin;
